<template>
  <div class="main-page">
    <template v-if="showHeader">
      <section class="page-section mb-3">
        <div class="container-fluid">
          <div class="grid card pt-2 pb-3 justify-content-between">
            <div class="col">
              <div class="">
                <div class="text-3xl font-bold mt-2">Complaint Tickets</div>
              </div>
            </div>
            <!-- <div class="col-12 md:col-3 lg:col-2">
              <div class="">
                <template v-if="$auth.canView('/complaints/add')">
                  <router-link :to="`/complaints/add`">
                    <Button
                      label="Create New Ticket"
                      icon="pi pi-plus"
                      type="button"
                      class="w-full bg-primary p-button-rounded"
                    />
                  </router-link>
                </template>
              </div>
            </div> -->
            <div class="col-12 md:col-5 lg:col-4">
              <div class="">
                <span class="p-input-icon-left w-full">
                  <i class="pi pi-search" />
                  <InputText
                    outlined
                    dense
                    placeholder="Search"
                    class="w-full"
                    :value="searchText"
                    @input="
                      debounce(() => {
                        searchText = $event.target.value;
                      })
                    "
                  />
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>
    </template>
    <section class="page-section">
      <div class="container-fluid">
        <div class="grid">
          <div class="col-12 md:col-3 comp-grid">
            <div class="">
              <template v-if="$auth.canView('/complaints/add')">
                <router-link :to="`/complaints/add`">
                  <Button
                    label="Create New Ticket"
                    type="button"
                    class="w-full p-button-outlined p-button-rounded"
                  />
                </router-link>
              </template>
            </div>
            <hr />
            <div class="">
              <div class="mb-3">
                <div class="position-relative">
                  <div class="surface-100 p-3 font-bold text-md">
                    Created By
                  </div>
                  <api-data-source
                    api-path="components_data/complaintscreated_by_user"
                    v-slot="req"
                  >
                    <div v-if="req.loading" class="text-center">
                      <table class="p-datatable-table w-full">
                        <tbody>
                          <tr>
                            <td class="text-left" style="width: 100%">
                              <Skeleton height="3rem" class="m-2" />
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <Menu v-else class="w-full" :model="req.response">
                      <template #item="{ item }">
                        <router-link
                          :to="`/complaints/index/created_by/${item.value}?label=${item.label}&tag=Created By`"
                        >
                          <Button
                            class="p-button-text p-button-plain w-full flex justify-content-between align-items-center"
                          >
                            <span>{{ item.label }}</span>
                            <Chip
                              v-if="item.num"
                              :label="item.num"
                              class="text-sm"
                            />
                          </Button>
                        </router-link>
                      </template>
                    </Menu>
                  </api-data-source>
                </div>
              </div>
              <div class="mb-4">
                <div class="surface-100 p-3 font-bold text-md">
                  Filter by Date Created
                </div>
                <div class="p-2">
                  <Calendar
                    :showIcon="true"
                    :manualInput="false"
                    :showButtonBar="false"
                    dateFormat="yy-mm-dd"
                    hourFormat="24"
                    class="w-full"
                    selectionMode="range"
                    v-model="filters.complaints_date_created.value"
                    placeholder="Select date"
                    :inline="false"
                  />
                </div>
              </div>
              <div class="mb-3" v-if="!PRDepartmentUser()">
                <div class="position-relative">
                  <div class="surface-100 p-3 font-bold text-md">
                    Source of Complaint
                  </div>
                  <api-data-source
                    api-path="components_data/complaintssource_of_complaint_list"
                    v-slot="req"
                  >
                    <div v-if="req.loading" class="p-3 text-center">
                      <table class="p-datatable-table w-full">
                        <tbody>
                          <tr v-for="n in 3" :key="n">
                            <td class="text-left" style="width: 100%">
                              <Skeleton height="2rem" class="m-2" />
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <Menu v-else class="w-full" :model="req.response">
                      <template #item="{ item }">
                        <router-link
                          :to="`/complaints/index/source_of_complaint/${item.value}?label=${item.label}&tag=Source Of Complaint`"
                        >
                          <Button
                            class="p-button-text p-button-plain w-full flex justify-content-between align-items-center"
                          >
                            <span>{{ item.label }}</span>
                            <Chip
                              v-if="item.num"
                              :label="item.num"
                              class="text-sm"
                            />
                          </Button>
                        </router-link>
                      </template>
                    </Menu>
                  </api-data-source>
                </div>
              </div>
              <div class="mb-4">
                <div class="surface-100 p-3 font-bold text-md">
                  Filter by Status
                </div>
                <div class="p-2">
                  <Dropdown
                    class="w-full"
                    v-model="filters.complaints_status.value"
                    optionLabel="label"
                    optionValue="value"
                    :options="filters.complaints_status.options"
                    placeholder="Filter by status ..."
                  >
                  </Dropdown>
                </div>
              </div>
              <div class="mb-4">
                <div class="surface-100 p-3 font-bold text-md">
                  Filter by Severity
                </div>
                <div class="p-2">
                  <Dropdown
                    class="w-full"
                    v-model="filters.complaints_severity.value"
                    optionLabel="label"
                    optionValue="value"
                    :options="filters.complaints_severity.options"
                    placeholder="Filter by severity ..."
                  >
                  </Dropdown>
                </div>
              </div>
              <div class="mb-3" v-if="!PRDepartmentUser()">
                <div class="position-relative">
                  <div class="surface-100 p-3 font-bold text-md">
                    Filter by Complaint Type
                  </div>
                  <api-data-source
                    api-path="components_data/complaintscomplaint_type_list"
                    v-slot="req"
                    class="scrollbar"
                    id="style-1"
                  >
                    <div v-if="req.loading" class="p-3 text-center">
                      <table class="p-datatable-table w-full">
                        <tbody>
                          <tr v-for="n in 3" :key="n">
                            <td class="text-left" style="width: 100%">
                              <Skeleton height="2rem" class="m-2" />
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <Menu v-else class="w-full" :model="req.response">
                      <template #item="{ item }">
                        <router-link
                          :to="`/complaints/index/complaint_type/${item.value}?label=${item.label}&tag=Complaint Type`"
                        >
                          <Button
                            class="p-button-text p-button-plain w-full text-left flex justify-content-between align-items-start"
                          >
                            <span>{{ $utils.capitalize(item.label) }}</span>
                            <Chip
                              v-if="item.num"
                              :label="item.num"
                              class="text-sm"
                            />
                          </Button>
                        </router-link>
                      </template>
                    </Menu>
                  </api-data-source>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 md:col-9 comp-grid">
            <div class="">
              <div class="flex align-items-center justify-content-around">
                <div v-if="searchText" :class="filterTagClass">
                  <Breadcrumb
                    :home="{
                      icon: 'pi pi-times text-lg mr-3',
                      label: 'Search',
                    }"
                    :model="[
                      {
                        label: `${searchText}`,
                      },
                    ]"
                  >
                    <template #item="{ item }">
                      <div
                        class="cursor-pointer"
                        :class="item.icon"
                        @click="
                          () => {
                            clearSearch();
                          }
                        "
                      ></div>
                      <a :href="item.url">{{ item.label }}</a>
                    </template>
                  </Breadcrumb>
                </div>
                <div
                  v-if="filterHasValue(filters.complaints_date_created)"
                  :class="filterTagClass"
                >
                  <span class="text-primary"> Date Created</span>
                  <Chip
                    class="font-medium ml-2 px-3 py-1"
                    removable
                    @remove="removeFilter(filters.complaints_date_created)"
                  >
                    {{ getFilterLabel(filters.complaints_date_created) }}
                  </Chip>
                </div>
                <div
                  v-if="filterHasValue(filters.complaints_status)"
                  :class="filterTagClass"
                >
                  <Breadcrumb
                    :home="{
                      icon: 'pi pi-times text-lg mr-3',
                      label: 'Status',
                    }"
                    :model="[
                      {
                        label: `${getFilterLabel(filters.complaints_status)}`,
                      },
                    ]"
                  >
                    <template #item="{ item }">
                      <div
                        class="cursor-pointer"
                        :class="item.icon"
                        @click="
                          () => {
                            removeFilter(filters.complaints_status);
                          }
                        "
                      ></div>
                      <a :href="item.url">{{ item.label }}</a>
                    </template>
                  </Breadcrumb>
                </div>
                <div
                  v-if="filterHasValue(filters.complaints_severity)"
                  :class="filterTagClass"
                >
                  <Breadcrumb
                    :home="{
                      icon: 'pi pi-times text-lg mr-3',
                      label: 'Severity',
                    }"
                    :model="[
                      {
                        label: `${getFilterLabel(filters.complaints_severity)}`,
                      },
                    ]"
                  >
                    <template #item="{ item }">
                      <div
                        class="cursor-pointer"
                        :class="item.icon"
                        @click="
                          () => {
                            removeFilter(filters.complaints_severity);
                          }
                        "
                      ></div>
                      <a :href="item.url">{{ item.label }}</a>
                    </template>
                  </Breadcrumb>
                </div>
              </div>
              <div class="">
                <div>
                  <template v-if="showBreadcrumbs && $route.query.tag">
                    <Breadcrumb
                      :home="{ icon: 'pi pi-home', to: '/complaints' }"
                      :model="pageBreadCrumb"
                    />
                  </template>
                  <div class="grid justify-content-start">
                    <!-- Master Page Start -->
                    <div class="col-12">
                      <div class="" :class="{ card: !isSubPage }">
                        <!-- page records template -->
                        <div class="page-records" v-if="!loading">
                          <DataTable
                            :lazy="true"
                            :loading="loading"
                            :value="records"
                            dataKey="complaint_id"
                            @sort="onSort($event)"
                            class=""
                            :showGridlines="false"
                            :rowHover="true"
                            responsiveLayout="stack"
                          >
                            <Column
                              field="ticket_id"
                              header="Ticket Id"
                              :sortable="true"
                            >
                              <template #body="{ data }">
                                <router-link
                                  :to="`/complaints/view/${data.complaint_id}`"
                                >
                                  {{ data.ticket_id }}
                                </router-link>
                              </template>
                            </Column>
                            <Column
                              field="complaint_type"
                              header="Complaint Type"
                              :sortable="true"
                            >
                              <template #body="{ data }">
                                {{ $utils.capitalize(data.complaint_type) }}
                              </template>
                            </Column>
                            <Column
                              field="client_id"
                              header="Telephone"
                              :sortable="true"
                            >
                              <template #body="{ data }">
                                {{ data.client_id }}
                              </template>
                            </Column>
                            <Column
                              field="source_of_complaint"
                              header="Source Of Complaint"
                              :sortable="true"
                            >
                              <template #body="{ data }">
                                {{ data.source_of_complaint }}
                              </template>
                            </Column>
                            <Column
                              field="status"
                              header="Status"
                              :sortable="true"
                            >
                              <template #body="{ data }">
                                <Tag
                                  v-if="data.status == 'opened'"
                                  class="bg-cyan-700"
                                  rounded
                                  :value="$utils.capitalize(data.status)"
                                ></Tag>
                                <Tag
                                  v-else-if="data.status == 'closed'"
                                  class="bg-green-400"
                                  rounded
                                  :value="$utils.capitalize(data.status)"
                                ></Tag>
                                <Tag
                                  v-else-if="data.status == 'prank'"
                                  class=""
                                  rounded
                                  severity="warning"
                                  :value="$utils.capitalize(data.status)"
                                ></Tag>
                                <Tag
                                  v-else
                                  class="bg-gray-500"
                                  rounded
                                  :value="$utils.capitalize(data.status)"
                                ></Tag>
                              </template>
                            </Column>
                            <Column
                              field="date_created"
                              header="Date Created"
                              :sortable="true"
                            >
                              <template #body="{ data }">
                                {{ $utils.humanDatetime(data.date_created) }}
                              </template>
                            </Column>
                            <Column
                              headerStyle="width: 3em"
                              headerClass="text-center"
                            >
                              <template #body="{ data }">
                                <SplitButton
                                  class="p-button p-button-raised p-button-text p-button-sm"
                                  :model="getActionMenuModel(data)"
                                >
                                  <i></i>
                                </SplitButton>
                              </template>
                            </Column>
                          </DataTable>
                        </div>
                        <!-- page loading indicator -->
                        <template v-if="loading">
                          <div>
                            <DataTable
                              :value="[1, 2, 3, 4, 5, 6, 7, 8, 9]"
                              responsiveLayout="scroll"
                            >
                              <Column style="width: 3rem">
                                <template #body>
                                  <Skeleton shape="circle" size="2rem" />
                                </template>
                              </Column>
                              <Column>
                                <template #body>
                                  <Skeleton />
                                </template>
                              </Column>
                              <Column>
                                <template #body>
                                  <Skeleton borderRadius="16px" />
                                </template>
                              </Column>
                              <Column>
                                <template #body>
                                  <Skeleton />
                                </template>
                              </Column>
                              <Column style="width: 3rem">
                                <template #body>
                                  <Skeleton size="2rem" />
                                </template>
                              </Column>
                            </DataTable>
                          </div>
                        </template>
                        <!-- end of page loading indicator-->
                        <!-- Empty record -->
                        <template v-if="pageReady && !records.length">
                          <div
                            class="p-3 my-3 text-500 text-lg font-medium text-center"
                          >
                            No record found
                          </div>
                        </template>
                        <!-- end of empty record-->
                        <!-- pagination component-->
                        <template v-if="showFooter">
                          <div class="">
                            <div v-show="pageReady">
                              <div class="flex justify-content-between">
                                <div
                                  class="flex justify-content-center flex-grow-0"
                                >
                                  <div
                                    class="m-2"
                                    v-if="exportButton && records.length"
                                  >
                                    <Button
                                      @click="
                                        (event) =>
                                          $refs.exportMenu.toggle(event)
                                      "
                                      label=""
                                      title="Export"
                                      icon="pi pi-print"
                                    />
                                    <Menu
                                      ref="exportMenu"
                                      popup
                                      :model="pageExportFormats"
                                    />
                                  </div>
                                </div>
                                <div
                                  v-if="paginate && totalPages > 1"
                                  class="flex-grow-1"
                                >
                                  <Paginator
                                    class="border-none bg-transparent py-3"
                                    :first="recordsPosition"
                                    @page="
                                      (event) => {
                                        pagination.page = event.page + 1;
                                      }
                                    "
                                    :rows="pagination.limit"
                                    :totalRecords="totalRecords"
                                  >
                                    <template #start>
                                      <span class="text-sm text-gray-500 px-2">
                                        Records
                                        <b
                                          >{{ recordsPosition }} of
                                          {{ totalRecords }}</b
                                        >
                                      </span>
                                    </template>
                                    <template #end>
                                      <Dropdown
                                        v-model="pagination.limit"
                                        :options="[
                                          5, 10, 15, 20, 30, 40, 50, 100,
                                        ]"
                                      ></Dropdown>
                                    </template>
                                  </Paginator>
                                </div>
                              </div>
                            </div>
                          </div>
                        </template>
                        <!-- end of pagination component-->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script setup>
import { useApp } from "@/composables/app.js";
import { useAuth } from "@/composables/auth";
import { useListPage } from "@/composables/listpage.js";
import { utils } from "@/utils";
import { onMounted, reactive, toRefs } from "vue";
import { useRoute } from "vue-router";
const props = defineProps({
  primaryKey: {
    type: String,
    default: "complaint_id",
  },
  pageName: {
    type: String,
    default: "complaints",
  },
  routeName: {
    type: String,
    default: "complaintslist",
  },
  apiPath: {
    type: String,
    default: "complaints/index",
  },
  paginate: {
    type: Boolean,
    default: true,
  },
  showHeader: {
    type: Boolean,
    default: true,
  },
  showFooter: {
    type: Boolean,
    default: true,
  },
  showBreadcrumbs: {
    type: Boolean,
    default: true,
  },
  exportButton: {
    type: Boolean,
    default: true,
  },
  importButton: {
    type: Boolean,
    default: false,
  },
  multiCheckbox: {
    type: Boolean,
    default: false,
  },
  emptyRecordMsg: {
    type: String,
    default: "No record found",
  },
  titleBeforeDelete: {
    type: String,
    default: "Delete record",
  },
  msgBeforeDelete: {
    type: String,
    default: "Are you sure you want to delete this record?",
  },
  msgAfterDelete: {
    type: String,
    default: "Record deleted successfully",
  },
  page: {
    type: Number,
    default: 1,
  },
  limit: {
    type: Number,
    default: 15,
  },
  mergeRecords: {
    // for infinite loading
    type: Boolean,
    default: false,
  },
  search: {
    type: String,
    default: "",
  },
  fieldName: null,
  fieldValue: null,
  sortBy: {
    type: String,
    default: "",
  },
  sortType: {
    type: String,
    default: "", //desc or asc
  },
  isSubPage: {
    type: Boolean,
    default: false,
  },
  filterTagClass: {
    type: String,
    default:
      "surface-card p-2 text-500 flex-grow-1 text-center m-1 mb-3 flex-grow-1 text-center",
  },
});
const route = useRoute();
const app = useApp();
const auth = useAuth();
const filters = reactive({
  complaints_date_created: {
    value: "",
    valueType: "range-date",
    options: [],
  },
  complaints_status: {
    value: "",
    valueType: "single",
    options: app.menus.complaintsStatusItems,
  },
  complaints_severity: {
    value: "",
    valueType: "single",
    options: app.menus.complaintsSeverityItems,
  },
});

//init list page hook
const page = useListPage(props, filters);
//page state
const {
  totalRecords, // total records from api - Number
  recordCount, // current record count - Number
  loading, // Api loading state - Boolean
  selectedItems, // Data table selected items -Array
  pagination, //Pagination object - Object
  searchText, // search text - String
  pageReady, // api data loaded successfully
} = toRefs(page.state);
//page computed propties
const {
  records, // page record from store - Array
  apiUrl, // current api path - URL
  currentRecord, // master detail selected record - Object
  pageBreadCrumb, // get page navigation paths - Object
  canLoadMore, // if api has more data for loading - Boolean
  finishedLoading, // if api has finished loading - Boolean
  totalPages, // total number of pages from api - Number
  recordsPosition, // current record position from api - Number
} = page.computedProps;
//page methods
const {
  load, // load data from api
  reload, // reset pagination and load data
  loadNextPage, // load next page
  loadPreviousPage, // load previous page
  exportPage, // export page records - args = (exportFormats, apiUrl, pageName)
  clearSearch, // clear input search
  debounce, // debounce input search
  onSort, // reset page number before sort from api
  deleteItem, // delete item by id or selected items - args = (id) or (selectedItems)
  setCurrentRecord, // master detail set current record
  isCurrentRecord, // master detail
  removeFilter, // remove page filter item - args = (filter.propertyname)
  getFilterLabel, // get filter item display label - args = (filter.propertyname)
  filterHasValue, //check if filter item has value - args = (filter.propertyname)
  importComplete, // reload page after data import
} = page.methods;
const pageExportFormats = [
  {
    label: "Excel",
    icon: "pi pi-file-excel text-green-500",
    command: () => {
      app.exportPageRecords("excel", apiUrl, props.pageName, "xlsx");
    },
  },
];
function getActionMenuModel(data) {
  return [
    {
      label: "View",
      to: `/complaints/view/${data.complaint_id}`,
      icon: "pi pi-eye",
      visible: auth.canView("complaints/view"),
    },
    {
      label: "Update Ticket",
      command: (event) => {
        app.openPageDialog({
          page: "complaints/edit",
          url: `/complaints/edit/${data.complaint_id}`,
          closeBtn: true,
          persistent: true,
          position: "bottom",
        });
      },
      icon: "pi pi-pencil",
      visible: auth.canView("complaints/edit"),
    },
  ];
}


function PRDepartmentUser() {
  const userRegion = auth.userRegion?.toLowerCase();
  const userDistrict = auth.userDistrict?.toLowerCase();
  return userRegion === "ghana water" && userDistrict === "pr department";
}


function getDateRangeArray(date_filter) {
  const today = new Date();
  const utcToday = new Date(Date.UTC(today.getUTCFullYear(), today.getUTCMonth(), today.getUTCDate()));

  const startOfYear = (year) => new Date(Date.UTC(year, 0, 1));
  const endOfYear = (year) => new Date(Date.UTC(year, 11, 31));

  let startDate = null;
  let endDate = null;

  switch (date_filter) {
    case "Today":
      startDate = endDate = utcToday;
      break;

    case "Yesterday":
      startDate = endDate = new Date(Date.UTC(utcToday.getUTCFullYear(), utcToday.getUTCMonth(), utcToday.getUTCDate() - 1));
      break;

    case "Last 3 Days":
      startDate = new Date(Date.UTC(utcToday.getUTCFullYear(), utcToday.getUTCMonth(), utcToday.getUTCDate() - 3));
      endDate = utcToday;
      break;

    case "Last 7 Days":
      startDate = new Date(Date.UTC(utcToday.getUTCFullYear(), utcToday.getUTCMonth(), utcToday.getUTCDate() - 7));
      endDate = utcToday;
      break;

    case "Last 30 Days":
      startDate = new Date(Date.UTC(utcToday.getUTCFullYear(), utcToday.getUTCMonth(), utcToday.getUTCDate() - 30));
      endDate = utcToday;
      break;

    case "Last 60 Days":
      startDate = new Date(Date.UTC(utcToday.getUTCFullYear(), utcToday.getUTCMonth(), utcToday.getUTCDate() - 60));
      endDate = utcToday;
      break;

    case "Last 90 Days":
      startDate = new Date(Date.UTC(utcToday.getUTCFullYear(), utcToday.getUTCMonth(), utcToday.getUTCDate() - 90));
      endDate = utcToday;
      break;

    case "Last Year":
      const lastYear = utcToday.getUTCFullYear() - 1;
      startDate = startOfYear(lastYear);
      endDate = endOfYear(lastYear);
      break;

    case "2 Years Ago":
      const twoYearsAgo = utcToday.getUTCFullYear() - 2;
      startDate = startOfYear(twoYearsAgo);
      endDate = endOfYear(twoYearsAgo);
      break;

    case "3 Years Ago":
      const threeYearsAgo = utcToday.getUTCFullYear() - 3;
      startDate = startOfYear(threeYearsAgo);
      endDate = endOfYear(threeYearsAgo);
      break;

    case "Only This Year":
      const thisYear = utcToday.getUTCFullYear();
      startDate = startOfYear(thisYear);
      endDate = endOfYear(thisYear);
      break;

    default:
      return [];
  }

  return [startDate, endDate];
}


 

onMounted(() => {
  const pageTitle = "Complaints";
  app.setPageTitle(props.routeName, pageTitle);
  // Check and apply route query to filters
  if (route.query.complaints_status) {
    filters.complaints_status.value = route.query.complaints_status;
  }
 if (route.query.date_filter) {
    filters.complaints_date_created.value = getDateRangeArray(route.query.date_filter);
  }
 

  load();
});
</script>
<style scoped>
.router-link-active .router-link-exact-active {
  background-color: #deddf1;
}

.scrollbar {
  float: left;
  height: 300px;
  width: 100%;
  background: #f5f5f5;
  overflow-y: scroll;
  margin-bottom: 25px;
  overflow-x: hidden;
}

#style-1::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(87, 87, 87, 0.3);
  border-radius: 10px;
  background-color: #f5f5f5;
}

#style-1::-webkit-scrollbar {
  width: 6px;
  background-color: #f5f5f5;
}
</style>
